/** Wiki templates, compile mode, and the onboarding stepper (EN source of truth + VI); spread into the main dictionaries */

export const setupEn = {
  'wikiTemplate.label': 'Wiki template',
  'wikiTemplate.hint': 'The fixed sections your compiled wiki starts with. Topics found in your Sources are added after them.',
  'wikiTemplate.software': 'Software',
  'wikiTemplate.research': 'Research',
  'wikiTemplate.personal': 'Personal',
  'wikiTemplate.custom': 'Custom',
  'wikiTemplate.software.hint': 'For a codebase: architecture, modules, APIs, decisions, runbooks.',
  'wikiTemplate.research.hint': 'For a study: question, findings, methods, sources reviewed.',
  'wikiTemplate.personal.hint': 'For yourself: notes, plans, ideas, reading, journal.',
  'wikiTemplate.custom.hint': 'No fixed sections: only the topics found in your Sources.',
  'wikiTemplate.sections': 'Sections: {sections}',

  'wiki.topicsHeading': 'Topics',
  'wiki.noPageYet': 'No page yet',

  'compileMode.label': 'Compile mode',
  'compileMode.hint': 'Which way of compiling the wiki is shown first. Both stay available.',
  'compileMode.agent': 'In your agent (free)',
  'compileMode.agent.hint': 'Your coding agent reads the compile brief and writes cited pages through the CLI or MCP. No credits.',
  'compileMode.server': 'On AgentWiki (credits)',
  'compileMode.server.hint': 'AgentWiki compiles with your workspace AI provider and bills credits. Nothing to run on your machine.',
  'compileMode.saved': 'Compile mode saved',
  'compileMode.saveFailed': 'Could not save the compile mode: {message}',

  'compile.agent.title': 'Compile in your agent',
  'compile.agent.free': 'Free',
  'compile.agent.hint': 'Run this in your repository and let your coding agent follow the brief. It saves each page with `agentwiki wiki put`.',
  'compile.agent.mcp': 'With MCP: ask your agent to call wiki_compile_brief, then save each page with wiki_page_upsert.',
  'compile.agent.commands': 'Compile commands',
  'compile.other.server': 'Or compile on AgentWiki (credits)',
  'compile.other.agent': 'Or compile in your agent (free)',
  'compile.modeHint': 'Choose which one comes first in Settings → Preferences.',

  'connect.copy': 'Copy',
  'connect.copied': 'Copied',
  'connect.copyNamed': 'Copy {name}',

  'onboarding.steps': 'Setup steps',
  'onboarding.stepOf': 'Step {current} of {total}',
  'onboarding.step.project': 'Project',
  'onboarding.step.agent': 'Connect an agent',
  'onboarding.step.compile': 'Compile mode',
  'onboarding.back': 'Back',
  'onboarding.next': 'Next',
  'onboarding.finish': 'Finish',
  'onboarding.agent.title': 'Connect your agent',
  'onboarding.agent.intro': 'Your agent pushes Sources into {project} and compiles the wiki. Pick how it connects; you can add more later.',
  'onboarding.agent.tabs': 'Connection method',
  'onboarding.agent.claude-code': 'Run in your repository:',
  'onboarding.agent.codex': 'Add to ~/.codex/config.toml and set the key in your shell:',
  'onboarding.agent.cursor': 'Add to .cursor/mcp.json in your repository:',
  'onboarding.agent.cli': 'Install the CLI, sign in, and pick this project for the repository:',
  'onboarding.agent.keyTitle': 'API key',
  'onboarding.agent.keyHint': 'The snippets need an API key. Create one now (it is shown once) or use one you already have.',
  'onboarding.agent.createKey': 'Create an API key',
  'onboarding.agent.creatingKey': 'Creating…',
  'onboarding.agent.keyName': 'Agent (onboarding)',
  'onboarding.agent.keyCreated': 'Key created. Copy it now: it is not shown again. The snippets below already include it.',
  'onboarding.agent.keyFailed': 'Could not create the key: {message}',
  'onboarding.agent.manageKeys': 'Manage API keys',
  'onboarding.agent.docs': 'Full setup guide',
  'onboarding.compile.title': 'How should the wiki be compiled?',
  'onboarding.compile.intro': 'Compiling turns your Sources into cited wiki pages. Choose which way is shown first; you can always use the other one.',
}

export const setupVi: Record<keyof typeof setupEn, string> = {
  'wikiTemplate.label': 'Mẫu wiki',
  'wikiTemplate.hint': 'Các mục cố định mà wiki đã biên dịch bắt đầu với. Những chủ đề tìm thấy trong Nguồn được thêm sau các mục này.',
  'wikiTemplate.software': 'Phần mềm',
  'wikiTemplate.research': 'Nghiên cứu',
  'wikiTemplate.personal': 'Cá nhân',
  'wikiTemplate.custom': 'Tuỳ chỉnh',
  'wikiTemplate.software.hint': 'Cho một codebase: kiến trúc, mô-đun, API, quyết định, hướng dẫn vận hành.',
  'wikiTemplate.research.hint': 'Cho một nghiên cứu: câu hỏi, kết quả, phương pháp, tài liệu đã xem.',
  'wikiTemplate.personal.hint': 'Cho riêng bạn: ghi chú, kế hoạch, ý tưởng, đọc, nhật ký.',
  'wikiTemplate.custom.hint': 'Không có mục cố định: chỉ gồm các chủ đề tìm thấy trong Nguồn.',
  'wikiTemplate.sections': 'Các mục: {sections}',

  'wiki.topicsHeading': 'Chủ đề',
  'wiki.noPageYet': 'Chưa có trang',

  'compileMode.label': 'Chế độ biên dịch',
  'compileMode.hint': 'Cách biên dịch wiki được hiện trước. Cả hai cách vẫn luôn dùng được.',
  'compileMode.agent': 'Trong agent (miễn phí)',
  'compileMode.agent.hint': 'Coding agent của bạn đọc bản hướng dẫn biên dịch rồi viết các trang có trích dẫn qua CLI hoặc MCP. Không tốn credits.',
  'compileMode.server': 'Trên AgentWiki (tính credits)',
  'compileMode.server.hint': 'AgentWiki biên dịch bằng nhà cung cấp AI của workspace và trừ credits. Không cần chạy gì trên máy bạn.',
  'compileMode.saved': 'Đã lưu chế độ biên dịch',
  'compileMode.saveFailed': 'Không lưu được chế độ biên dịch: {message}',

  'compile.agent.title': 'Biên dịch trong agent',
  'compile.agent.free': 'Miễn phí',
  'compile.agent.hint': 'Chạy lệnh này trong repo và để coding agent làm theo bản hướng dẫn. Agent lưu từng trang bằng `agentwiki wiki put`.',
  'compile.agent.mcp': 'Qua MCP: nhờ agent gọi wiki_compile_brief, rồi lưu từng trang bằng wiki_page_upsert.',
  'compile.agent.commands': 'Lệnh biên dịch',
  'compile.other.server': 'Hoặc biên dịch trên AgentWiki (tính credits)',
  'compile.other.agent': 'Hoặc biên dịch trong agent (miễn phí)',
  'compile.modeHint': 'Chọn cách nào hiện trước trong Cài đặt → Tuỳ chọn.',

  'connect.copy': 'Sao chép',
  'connect.copied': 'Đã sao chép',
  'connect.copyNamed': 'Sao chép {name}',

  'onboarding.steps': 'Các bước thiết lập',
  'onboarding.stepOf': 'Bước {current}/{total}',
  'onboarding.step.project': 'Dự án',
  'onboarding.step.agent': 'Kết nối agent',
  'onboarding.step.compile': 'Chế độ biên dịch',
  'onboarding.back': 'Quay lại',
  'onboarding.next': 'Tiếp theo',
  'onboarding.finish': 'Hoàn tất',
  'onboarding.agent.title': 'Kết nối agent của bạn',
  'onboarding.agent.intro': 'Agent đẩy Nguồn vào {project} và biên dịch wiki. Chọn cách kết nối; bạn có thể thêm cách khác sau.',
  'onboarding.agent.tabs': 'Cách kết nối',
  'onboarding.agent.claude-code': 'Chạy trong repo của bạn:',
  'onboarding.agent.codex': 'Thêm vào ~/.codex/config.toml và đặt key trong shell:',
  'onboarding.agent.cursor': 'Thêm vào .cursor/mcp.json trong repo của bạn:',
  'onboarding.agent.cli': 'Cài CLI, đăng nhập và chọn dự án này cho repo:',
  'onboarding.agent.keyTitle': 'API key',
  'onboarding.agent.keyHint': 'Các đoạn cấu hình cần một API key. Tạo key ngay (chỉ hiện một lần) hoặc dùng key bạn đã có.',
  'onboarding.agent.createKey': 'Tạo API key',
  'onboarding.agent.creatingKey': 'Đang tạo…',
  'onboarding.agent.keyName': 'Agent (lúc bắt đầu)',
  'onboarding.agent.keyCreated': 'Đã tạo key. Hãy sao chép ngay vì key sẽ không hiện lại. Các đoạn cấu hình bên dưới đã có sẵn key.',
  'onboarding.agent.keyFailed': 'Không tạo được key: {message}',
  'onboarding.agent.manageKeys': 'Quản lý API key',
  'onboarding.agent.docs': 'Hướng dẫn cài đặt đầy đủ',
  'onboarding.compile.title': 'Bạn muốn biên dịch wiki theo cách nào?',
  'onboarding.compile.intro': 'Biên dịch biến Nguồn thành các trang wiki có trích dẫn. Chọn cách được hiện trước; cách còn lại vẫn luôn dùng được.',
}
